/* tslint:disable */ /* eslint-disable */
import * as Types from '../../../models/generated/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GlobalOverallCommentsCountQueryVariables = Types.Exact<{
  isUserAllowedToReadComments: Types.Scalars['Boolean'];
  surveyContentType: Types.SurveyContentType;
}>;


export type GlobalOverallCommentsCountQuery = { commentsStatistics: { overallCommentsCount: number } };


export const GlobalOverallCommentsCountDocument = gql`
    query GlobalOverallCommentsCount($isUserAllowedToReadComments: Boolean!, $surveyContentType: SurveyContentType!) {
  commentsStatistics: getStatisticsGlobal(surveyContentType: $surveyContentType) @include(if: $isUserAllowedToReadComments) {
    overallCommentsCount: number_of_recipient_comments
  }
}
    `;

/**
 * __useGlobalOverallCommentsCountQuery__
 *
 * To run a query within a React component, call `useGlobalOverallCommentsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalOverallCommentsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalOverallCommentsCountQuery({
 *   variables: {
 *      isUserAllowedToReadComments: // value for 'isUserAllowedToReadComments'
 *      surveyContentType: // value for 'surveyContentType'
 *   },
 * });
 */
export function useGlobalOverallCommentsCountQuery(baseOptions: Apollo.QueryHookOptions<GlobalOverallCommentsCountQuery, GlobalOverallCommentsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GlobalOverallCommentsCountQuery, GlobalOverallCommentsCountQueryVariables>(GlobalOverallCommentsCountDocument, options);
      }
export function useGlobalOverallCommentsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GlobalOverallCommentsCountQuery, GlobalOverallCommentsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GlobalOverallCommentsCountQuery, GlobalOverallCommentsCountQueryVariables>(GlobalOverallCommentsCountDocument, options);
        }
export type GlobalOverallCommentsCountQueryHookResult = ReturnType<typeof useGlobalOverallCommentsCountQuery>;
export type GlobalOverallCommentsCountLazyQueryHookResult = ReturnType<typeof useGlobalOverallCommentsCountLazyQuery>;
export type GlobalOverallCommentsCountQueryResult = Apollo.QueryResult<GlobalOverallCommentsCountQuery, GlobalOverallCommentsCountQueryVariables>;